import React from 'react';
import {
  Edit,
  FormTab,
  required,
  TextInput,
  useTranslate,
  TabbedForm,
  useNotify,
  useRefresh,
  useRedirect
} from 'react-admin';
import { useParams } from 'react-router-dom';



export function GroupEdit() {
  const { id } = useParams<{id:string}>();
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(
      'ra.notification.updated',
      {
          type: 'info',
          messageArgs: { smart_count: 1 },
          undoable: true,
      }
    );
    redirect('/inspections/groups');
    refresh();
  };

  return (
    <Edit
      basePath={'/inspections/groups'}
      resource={'groups'}
      onSuccess={onSuccess}
      id={id}
    >
      <TabbedForm>
        <FormTab
          label={translate('resources.groups.group')}
        >
          <TextInput disabled source="id" />
          <TextInput source="serial" validate={required()} />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}